import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { formatPhoneNumber } from '../utils';
import Typography from '@mui/material/Typography';

const useConnectionOptions = () => {
  const account = useSelector((s) => s.settings.account);
  const user = useSelector((s) => s.user.user);
  const { use_trial_number_only } = user;

  const connections = useMemo(() => {
    const l =
      (user.users_record_is_admin === '1'
        ? account.connections
        : user.connections) || [];
    return l.map((c) => ({
      ...c,
      label: (
        <>
          <Typography color="text.secondary">{c.connection_name}</Typography>
          <Typography fontWeight={500}>
            {formatPhoneNumber(c.conn_address)}
          </Typography>
        </>
      ),
      address: formatPhoneNumber(c.conn_address),
      value: c.conn_id,
      is_primary: c.is_primary === '1',
      disabled: use_trial_number_only && c.is_trial_number !== '1',
    }));
  }, [account, user]);

  return connections;
};

export default useConnectionOptions;
